import { render, staticRenderFns } from "./OrderContentCustomer.vue?vue&type=template&id=040e2193&scoped=true&"
import script from "./OrderContentCustomer.vue?vue&type=script&lang=ts&"
export * from "./OrderContentCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./OrderContentCustomer.vue?vue&type=style&index=0&id=040e2193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e2193",
  null
  
)

export default component.exports